/**
 * IMA request contexts.
 *
 * PREFETCH:
 *   Pre-roll prefetch request.
 *
 * CONTENT:
 *   Normal content ad schedule:
 *   pre-roll + mid-roll + post-roll.
 */
export const AD_REQUEST_CONTEXT = {
  PREFETCH: 'prefetchAdsManager',
  CONTENT: 'contentAdsManager',
} as const;
